﻿$.fn.dxCtrlSwitch = function custom_dxCtrlSwitch(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlswitch");
        this.instance = new cdxCtrlSwitch(this, option);
    }
    return this;
}

window.cdxCtrlSwitch = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
            //if (name == "disabled" && $TdText) 
        }
    }

    var dx = null;
    var $TdText = null
    function mConstruit() {
        container.empty();
        container.css("height", "23px")

        var oncontentready = option.onContentReady
        option.onContentReady = function (e) {
            e.component.element().find(".dx-switch-on").css({ "font-size": "80%", "text-align": "right", "padding-right": "25px" })
            e.component.element().find(".dx-switch-off").css({ "font-size": "80%", "text-align": "left", "padding-left": "5px" })
            if (typeof oncontentready != 'undefined') oncontentready(e)
        }

        var onvaluechanged = option.onValueChanged
        option.onValueChanged = function (e) {
            option.value = e.value
            if ($TdText) $TdText.css("opacity",((option.value) ? 1 : 0.3))
            if (typeof onvaluechanged != 'undefined') onvaluechanged(e)
        }

        if (option.labelMode == "floating") {
            container.css({ "position": "relative", "padding-top": "5px" })
            $DivLabel = $('<div class="dx-texteditor-label" style="left: 16px;"><div class="dx-label-before" style="width: 0px;"></div><div class="dx-label"><span data-mark="">' + option.label + '</span></div><div class="dx-label-after"></div></div>').appendTo(container)
            container.css({
                "height": "33px",
                "padding-top": "15px"
            })
        }
        if (typeof option.focusStateEnabled == "undefined") option.focusStateEnabled = false

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip)
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        if (typeof option.width == 'undefined') option.width = 50

        if (typeof option.text == 'undefined') {
            dx = $("<div/>").appendTo(container).dxSwitch(option).dxSwitch("instance");
        } else {
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:60px;overflow:hidden;'/>").appendTo($Tr)
            dx = $("<div/>").appendTo($Td).dxSwitch(option).dxSwitch("instance");
            $TdText = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-family:barlow condensed;vertical-align:top;'/>").appendTo($Tr)
            $TdText.css("opacity", ((option.value) ? 1 : 0.3))
            $TdText.text(option.text)
        }

    }

    this.element = function () { return container }
    this.component = function () { return dx }

    mConstruit();
}